//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('docCategoryLang', {
//        templateUrl: 'views/components/views/docCategoryLang/docCategoryLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'docCategoryLangService', function ($stateParams, stateService, translateService, docCategoryLangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let docCategoryKeyno = $stateParams.doccategory_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await docCategoryLangService.listLanguages({ doccategory_keyno: docCategoryKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                docCategoryLangService.saveObj({ records: vm.model.inputListLanguages }).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
